import { useField, useFormikContext } from "formik";
import InputMask from "react-input-mask";

const PhoneInput = (props) => {
  const { label, name } = props;
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  const handleInput = ({ target: { value } }) => {
    const val = value.replace(/\D/g, "");
    setFieldValue(name, val);
  };

  const configTextfield = {
    ...field,
    error: false,
    helperText: "",
    value: field.value,
  };

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true;
    configTextfield.helperText = meta.error;
  }
  return (
    <div
      className={
        meta && meta.touched && meta.error
          ? "form-input error-form"
          : "form-input"
      }
    >
      <label htmlFor={name}>{label}</label>
      <InputMask
        value={field.value}
        mask="(599)-999-99-99"
        className={
          meta && meta.touched && meta.error
            ? "input form-control error"
            : "input form-control"
        }
        onChange={handleInput}
      />
      {/*  <input type="text" {...configTextfield} className="form-control" /> */}
      {meta && meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default PhoneInput;
